import { DraggableEvent_ } from './eventTypes/DraggableEvent_';
import { Event_ } from './Event_';
import { TouchEvent_ } from './eventTypes/TouchEvent_';
import { FormEvent_ } from './eventTypes/FormEvent_';
import { FocusEvent_ } from './eventTypes/FocusEvent_';
import { ClipboardEvent_ } from './eventTypes/ClipboardEvent_';
import { ScrollEvent_ } from './eventTypes/ScrollEvent_';
import { WheelEvent_ } from './eventTypes/WheelEvent_';
import { AnimationEvent_ } from './eventTypes/AnimationEvent_';
import { KeyboardEvent_ } from './eventTypes/KeyboardEvent_';
import { CompositionEvent_ } from './eventTypes/CompositionEvent_';
import { MouseEvent_ } from './eventTypes/MouseEvent_';
import { TransitionEvent_ } from './eventTypes/TransitionEvent_';
export function getEventClass(t) {
    if ([
        'click',
        'contextmenu',
        'dblclick',
        'mousedown',
        'mouseup',
        'mouseenter',
        'mouseleave',
        'mouseover',
        'mouseout',
        'mousemove',
        'drag',
        'dragend',
        'dragenter',
        'dragexit',
        'dragleave',
        'dragover',
        'dragstart',
        'drop'
    ].includes(t)) {
        return MouseEvent_;
    }
    if (['keydown', 'keypress', 'keyup'].includes(t)) {
        return KeyboardEvent_;
    }
    if (['transitionend'].includes(t)) {
        return TransitionEvent_;
    }
    if (['draggablestart', 'draggabledrag', 'draggableend'].includes(t)) {
        return DraggableEvent_;
    }
    if (['touchcancel', 'touchend', 'touchmove', 'touchstart'].includes(t)) {
        return TouchEvent_;
    }
    if (['change', 'input', 'invalid', 'submit'].includes(t)) {
        return FormEvent_;
    }
    if (['focus', 'blur'].includes(t)) {
        return FocusEvent_;
    }
    if (['copy', 'cut', 'paste'].includes(t)) {
        return ClipboardEvent_;
    }
    if (['scroll'].includes(t)) {
        return ScrollEvent_;
    }
    if (['wheel'].includes(t)) {
        return WheelEvent_;
    }
    if (['animationstart', 'animationend', 'animationiteration'].includes(t)) {
        return AnimationEvent_;
    }
    if (['compositionstart', 'compositionupdate', 'compositionend'].includes(t)) {
        return CompositionEvent_;
    }
    return Event_;
}
